__turbopack_context__.v({
  "panelCloseIcon": "reading-tools-panels-module-scss-module__UG-_9q__panelCloseIcon",
  "panelEmptyMessage": "reading-tools-panels-module-scss-module__UG-_9q__panelEmptyMessage",
  "panelTitle": "reading-tools-panels-module-scss-module__UG-_9q__panelTitle",
  "readingToolPanel": "reading-tools-panels-module-scss-module__UG-_9q__readingToolPanel",
  "readingToolPanelHeader": "reading-tools-panels-module-scss-module__UG-_9q__readingToolPanelHeader",
  "readingToolPanelsContainer": "reading-tools-panels-module-scss-module__UG-_9q__readingToolPanelsContainer",
});
